import { render } from "./RiskRegister.vue?vue&type=template&id=7ea5a1bb&scoped=true"
import script from "./RiskRegister.js?vue&type=script&lang=js"
export * from "./RiskRegister.js?vue&type=script&lang=js"

import "./RiskRegister.vue?vue&type=style&index=0&id=7ea5a1bb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea5a1bb"]])

export default __exports__